import { useEffect, type Dispatch } from 'react';
import type { DeliveryActionEvent } from '../model/deliveryActionFlow';

// The success/generic-error banner clears itself after this long.
export const AUTO_DISMISS_MS = 5000;

// Clears a banner after AUTO_DISMISS_MS while `active`. Every flow in the slice wants exactly this
// rule — the «Acciones» card, «Ampliar custodia» and «Confirmar secuencia» — so it is one hook
// rather than three copies of the same effect. `dispatch` is stable across renders (useReducer).
//
// Callers gate `active` on the banner actually being ON SCREEN, not merely on the phase: a flow
// whose success refetch raises a skeleton over its own banner would otherwise spend the timeout
// behind it and clear a banner nobody saw.
export function useAutoDismiss(active: boolean, dispatch: Dispatch<DeliveryActionEvent>) {
  useEffect(() => {
    if (!active) return undefined;
    const timer = setTimeout(() => {
      dispatch({ type: 'DISMISS' });
    }, AUTO_DISMISS_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [active, dispatch]);
}
